import React, { useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./Contact.css";
import discord from "./assets/discord.svg";
import github from "./assets/github.svg";
import instagram from "./assets/instagram.svg";
import linkedin from "./assets/linkedin.svg";
import twitter from "./assets/twitter.svg";
import mail from "./assets/mail.svg";

import Image1 from "./assets/midwest.jpg";
import Image2 from "./assets/kbf.jpg";
import Image3 from "./assets/smores.jpg";
import Image4 from "./assets/kstate.jpg";
import Image5 from "./assets/india.jpg";

const contactLinks = [
  { icon: mail, name: "Email", url: "mailto:shrivasshivansh@gmail.com" },
  {
    icon: discord,
    name: "Discord",
    url: "https://discordapp.com/users/shivansh_shrivas",
  },
  {
    icon: linkedin,
    name: "LinkedIn",
    url: "https://linkedin.com/in/shivansh-shrivas",
  },
  { icon: github, name: "GitHub", url: "https://github.com/shivanshshrivas" },
  { icon: twitter, name: "Twitter", url: "https://x.com/shivansh6174" },
  {
    icon: instagram,
    name: "Instagram",
    url: "https://instagram.com/_shivansh_shrivas",
  },
];

const carouselImages = [Image1, Image2, Image3, Image4, Image5];

function Contact() {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: "center",
  });

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <div className="contact-section">
      <div className="contact-container">
        <div className="contact-header">Contact</div>
        <div className="contact-description">
          Feel free to reach out to me or checkout some of my pictures :)
        </div>
        <div className="main-container">
          <div className="contact-types">
            {contactLinks.map((contact, index) => (
              <div
                key={index}
                className="contact-type"
                onClick={() => window.open(contact.url, "_blank")}
              >
                <img src={contact.icon} alt={contact.name} />
                <div className="contact-type-name">{contact.name}</div>
              </div>
            ))}
          </div>
          <div className="embla">
            <div className="embla__viewport" ref={emblaRef}>
              <div className="embla__container">
                {carouselImages.map((image, index) => (
                  <div className="embla__slide" key={index}>
                    <img src={image} alt={`Carousel ${index + 1}`} />
                  </div>
                ))}
              </div>
            </div>
            <button className="embla__prev" onClick={scrollPrev}>
              <ChevronLeft size={24} />
            </button>
            <button className="embla__next" onClick={scrollNext}>
              <ChevronRight size={24} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
